import { getAuth, onAuthStateChanged } from "firebase/auth";

export const stateChange = () => {
  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (user) {
      // Utente loggato
      // Aggiorna il localStorage manualmente per forzare un evento storage
      // Questo tecnica permette di forzare un evento di storage che può essere ascoltato da altri componenti
      const email = localStorage.getItem("email");
      if (email) {
        // Salviamo temporaneamente lo stesso valore per forzare un evento storage
        localStorage.setItem("_tempEmail", email);
        localStorage.removeItem("_tempEmail");

        // In alternativa, dispatch di un evento custom
        const event = new Event("userAuthStateChanged");
        window.dispatchEvent(event);
      }
    } else {
      console.log("utente non loggato");
    }
  });
};
